import * as DesignPro from '@/components/mambas';
import lodash from 'lodash';
import Vue from 'vue';
import './antd';
import { valueTypeMap } from './extendsFields';
const EnumValueType = DesignPro.setValueTypeMap(valueTypeMap);
DesignPro.Locales.init({
    pagesContext: require.context('@/pages', true, /locales.ts$/),
});
lodash.set(Vue, 'valueType', EnumValueType);
Vue.use(DesignPro.install);
